/* External */
import { createContext, useContext, memo } from 'react';
import PropTypes from 'prop-types';

const ItemDataContext = createContext();

export function useItemData() {
  return useContext(ItemDataContext);
}

function BaseItemDataProvider({ itemData, children }) {
  return (
    <ItemDataContext.Provider value={itemData}>
      {children}
    </ItemDataContext.Provider>
  );
}

BaseItemDataProvider.propTypes = {
  itemData: PropTypes.shape({}),
  children: PropTypes.node,
};

const ItemDataProvider = memo(BaseItemDataProvider);

export { ItemDataProvider };
